import { ProductDetails } from '~/features/products/components/ProductDetails/ProductDetails';
import useStockStatusDetermined from '~/features/products/utils/stockState/useStockStatusDetermined';
import { useProductDetailTracking } from '~/features/tracking/hooks/useProductDetailTracking';
import { IModules, IP50ProductDetailPage } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks/components/DynamicBlockList/DynamicBlockList';

export type P50ProductDetailPageProps = IP50ProductDetailPage;
export const P50ProductDetailPage = ({ type, variationDetails, pageElements, usps, deliveryUrl, categoryBreadcrumb }: P50ProductDetailPageProps) => {
	// slideOpacity is 0 across all themes (--product-details-carousel-slide-opacity)
	const slideOpacity = 0;

	// Get stock status to start server side tracking.
	const stockStatus = useStockStatusDetermined(variationDetails.sku, variationDetails.stockAvailable, variationDetails.stockState, true);

	// tracking
	useProductDetailTracking(variationDetails);

	return (
		<>
			<ProductDetails
				variation={variationDetails}
				opacity={slideOpacity}
				stockStatus={stockStatus}
				usps={usps}
				deliveryUrl={deliveryUrl}
				categoryBreadcrumb={categoryBreadcrumb}
			/>
			<DynamicBlockList
				pageType={type}
				elements={pageElements as any as IModules[]}
			/>
		</>
	);
};
